"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntryAssetsScripts = (base, jsEntrypoints) => {
    return jsEntrypoints.map(entryChunk => `<script src="${base}/${entryChunk}"></script>`).join("\n");
};
//# sourceMappingURL=webpack-assets-manifest.js.map